/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable import/no-cycle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { Rnd } from 'react-rnd';
import { Modal, Select, MenuItem, Stack, Grid, Button, Box, Tooltip } from '@mui/material';
import { defaultModalOptions } from '../../shared/constantVariable';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import { convertUnitValues_flow, convertUnitValues_power, convertUnitValues_pressure } from '../../shared/conversion-helper/unitConversion';
import Notification from '../../shared/notification-modal';
import { getBorderColor } from '../../shared/utils';
import { closeIconBlack } from '../../shared/assets/images';
import './turbo-charger.scss';
import { output_data } from './output_data';

let unit_set_dict = { 'Volume Flow': 'gpm', 'Pressure': 'atm', 'Temperature': '°C', 'Liquid Volume': 'gal', 'Flux': 'gfd', 'Power': 'kW' };
const headerData = ['Parameter', 'Unit', 'Values'];
let output_dataCopy = JSON.parse(JSON.stringify(output_data));
let currentFlag = true;
let currentVal = 0;
const resRange = { min: 0, max: 0 };

const TurboChargerForm = (props) => {
  const { visibleTurbo, turboChargeDetails, turbocharger_all_unitop, handleCloseTurboCharger, disabledStripperAndExplorerTab, translateObject, setokbuttonFormAutoSave } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [isShowErrorMessage] = useState(false);
  const [turboChargeVal, setTurboChargeVal] = useState({});
  // add default dropdown value 1 if ROTC is not set
  const [tcParameter, setTcParameter] = useState([{}]);
  // set disable property if dropdown option is 8 and ROTC set 4 value next 4 value is disabled
  const [tcDisabled, setTcDisabled] = useState(0);
  // set default selected value in dropdown
  const [tcSelected, setTcSelected] = useState(1);
  let turbo_wheel = [...output_dataCopy.turbo_wheel];

  useEffect(() => {
    // roPump Get data that has the same parentnode value turbocharger_all_unitop and turboChargeDetails
    const turbodata = turbocharger_all_unitop.filter((ele) => {
      return (ele.parentNode === turboChargeDetails.parentNode && ele.id.indexOf('roPump') >= 0);
    });
    if (turbodata.length) {
      const data = get(JSON.parse(localStorage.getItem('ro-dict')), 'ro', '');
      if (data && Object.keys(data).length > 0) {
        const idata = data[turbodata[0].id];
        if (idata) {
          setTcParameter(idata['grid-data']);
          let count = -1;
          for (let i = 0; i < idata['grid-data'].length; i += 1) {
            if (idata['grid-data'][i].elementModel) {
              count += 1;
            }
          }
          setTcDisabled(count);
        }
      }
    }
  }, []);
  const getCurrentValue = (e) => {
    if (currentFlag) {
      currentFlag = false;
      currentVal = (e.target.value) ? Number(e.target.value) : 0;
    }
  };
  const handleCloseTurboChargerModal = () => {
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Are you sure you want to close this form?'),
        onYes: () => handleCloseTurboCharger(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleCloseTurboCharger();
    };
  };
  const setDataOnStorage = () => {
    const previous_pressure_unit = 'atm';
    // set the data in local storage value
    // tcSelected dropdown selectd value
    const turbocharger_obj = { 'Unit Type': 'TC', 'erd_type': 'turbo', 'turbo_on_stage': tcSelected, 'finalData': {} };
    turbo_wheel.forEach((ele) => {
      turbocharger_obj.finalData[ele.key] = ele.val;
      if (ele.key === 'turbo_on_stage') {
        turbocharger_obj.finalData[ele.key] = tcSelected;
      }
      if (['lp_dicharge_pres', 'cost_power', 'net_efficiency'].indexOf(ele.key) >= 0) {
        turbocharger_obj[ele.key] = Number(ele.val);
        if (ele.key === 'lp_dicharge_pres') {
          const convertedVal = Number(convertUnitValues_pressure(ele.val, unit_set_dict.Pressure, previous_pressure_unit));
          turbocharger_obj[ele.key] = Number(convertedVal);
          turbocharger_obj.finalData[ele.key] = convertedVal;
        }
      }
    });
    saveFormDataInLocalStorage({
      record: turbocharger_obj,
      type: 'TRD_data', // TRD_data
      id: turboChargeDetails.id,
      item: 'turbo_charger-dict' // turbo_charger-dict
    });
    localStorage.setItem('turbo-unit-work', JSON.stringify(unit_set_dict));
    handleCloseTurboCharger();
    getBorderColor(turboChargeDetails.id);
    setokbuttonFormAutoSave(true);
  };
  const decimalValue = (val) => {
    return val.toFixed(3);
  };
  const changeUnit = () => {
    const previous_pressure_unit = 'atm';
    let previousUnit = localStorage.getItem('turbo-unit-work');
    if (previousUnit) {
      previousUnit = JSON.parse(previousUnit);
    }
    let turbo_dict = localStorage.getItem('turbo_charger-dict');
    if (turbo_dict) {
      turbo_dict = get(JSON.parse(localStorage.getItem('turbo_charger-dict')), 'TRD_data', {});
      const { id } = turboChargeDetails;
      turbo_dict = (turbo_dict[id] && turbo_dict[id].finalData) ? turbo_dict[id].finalData : '';
    }
    turbo_wheel.forEach((ele) => {
      if (['RO_permeate_flow'].indexOf(ele.key) >= 0) {
        ele.unit = unit_set_dict['Volume Flow'];
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_flow(parseFloat(ele.val), previousUnit['Volume Flow'], unit_set_dict['Volume Flow'])));
        }
      } else if (['RO_feed_pressure', 'lp_dicharge_pres', 'membrane_pressure', 'boost_pressure', 'turbo_inlet_pressure', 'turbo_outlet_pressure'].indexOf(ele.key) >= 0) {
        ele.unit = unit_set_dict.Pressure;
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_pressure(parseFloat(ele.val), previousUnit.Pressure, unit_set_dict.Pressure)));
        }
      } else if (['energy_recovered', 'HP_power_consumed', 'power_savings', 'total_power_consumption'].indexOf(ele.key) >= 0) {
        ele.unit = unit_set_dict.Power;
        if (previousUnit) {
          ele.val = decimalValue(Number(convertUnitValues_power(parseFloat(ele.val), previousUnit.Power, unit_set_dict.Power)));
        }
      }
      if (turbo_dict) {
        // after open turbo form set the filled value.
        if (ele.key === 'turbo_on_stage') {
          setTcSelected(turbo_dict[ele.key] || ele.val);
        }
        if (['lp_dicharge_pres', 'cost_power', 'net_efficiency'].indexOf(ele.key) >= 0) {
          let val = Number(turbo_dict[ele.key]);
          if (ele.key === 'lp_dicharge_pres') {
            val = Number(convertUnitValues_pressure(val, previous_pressure_unit, unit_set_dict.Pressure));
          }
          ele.val = decimalValue(val);
        }
      }
    });
    setTurboChargeVal(turbo_wheel);
  };
  const blurVal = (ind, eve) => {
    turbo_wheel[ind].val = decimalValue(Number(eve.target.value));
    setTurboChargeVal(turbo_wheel);
    currentFlag = true;
  };
  const updateWorkExchangerValue = (data) => {
    for (let i = 0; i < turbo_wheel.length; i += 1) {
      turbo_wheel[i].val = data[turbo_wheel[i].outputkey] ? decimalValue(Number(data[turbo_wheel[i].outputkey])) : decimalValue(0);
    }
    changeUnit();
  };
  const showWarningMsg = (message) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      message, // `Target Resistivity must be between ${resRange.min} and ${resRange.max}`
      yesOrNo: false,
      onNo: () => setModalOption(defaultModalOptions)
    });
  };
  const changeVal = (ind, eve) => {
    if (turbo_wheel[ind].key === 'lp_dicharge_pres') {
      resRange.min = 0; resRange.max = 68.0457;
      const previous_pressure_unit = 'atm';
      if (unit_set_dict && unit_set_dict.Pressure) {
        resRange.min = Number(convertUnitValues_pressure(resRange.min, previous_pressure_unit, unit_set_dict.Pressure));
        resRange.max = Number(convertUnitValues_pressure(resRange.max, previous_pressure_unit, unit_set_dict.Pressure));
      }
      if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
        showWarningMsg(`LP Discharge Pressure must be between ${resRange.min} ${unit_set_dict.Pressure} and ${resRange.max} ${unit_set_dict.Pressure}`);
        turbo_wheel[ind].val = currentVal;
      } else {
        turbo_wheel[ind].val = eve.target.value;
      }
    } else if (turbo_wheel[ind].key === 'cost_power') {
      resRange.min = 0; resRange.max = 10;
      if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
        showWarningMsg(`Cost of Power must be between ${resRange.min} and ${resRange.max}`);
        turbo_wheel[ind].val = currentVal;
      } else {
        turbo_wheel[ind].val = eve.target.value;
      }
    } else if (turbo_wheel[ind].key === 'net_efficiency') {
      resRange.min = 0; resRange.max = 95;
      if (eve.target.value < resRange.min || eve.target.value > resRange.max) {
        showWarningMsg(`Net transfer Efficiencies must be between ${resRange.min} and ${resRange.max}`);
        turbo_wheel[ind].val = currentVal;
      } else {
        turbo_wheel[ind].val = eve.target.value;
      }
    }
    disabledStripperAndExplorerTab();
    setTurboChargeVal(turbo_wheel);
  };
  useEffect(() => {
    output_dataCopy = JSON.parse(JSON.stringify(output_data));
    turbo_wheel = [...output_dataCopy.turbo_wheel];

    if (localStorage.getItem('unit_set_dict')) {
      unit_set_dict = JSON.parse(localStorage.getItem('unit_set_dict'));
    }
    // Edit Case
    if (localStorage.getItem('ro_ouput_data')) {
      let data = JSON.parse(localStorage.getItem('ro_ouput_data'));
      if (data) {
        data = Object.values(JSON.parse(localStorage.getItem('ro_ouput_data'))).filter((ele) => {
          return ele.unit_type === 'TC';
        });
        if (data.length > 0) {
          data = data[0];
        }
        const turbo_data = data;
        if (Object.keys(turbo_data).length) {
          setTimeout(() => {
            updateWorkExchangerValue(turbo_data.output_user);
          }, 0);
        } else {
          changeUnit();
        }
      }
    } else {
      changeUnit();
    }
  }, []);
  const setSeletdValue = (event) => {
    setTcSelected(event.target.value);
  };
  return (
    <Modal hideBackdrop open={visibleTurbo} onClose={handleCloseTurboChargerModal} className='splitter-modal'>
      <Box>
        <Rnd
          default={{
            width: '70%',
            x: ((window.innerWidth / 2) - ((70 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((60 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='50%'
          cancel='.no_drag'
          className='turbo-charger-box'>
          <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
          <Grid className='turbo-charger-wrapper'>
            <Grid item xs={12} className='turbo-charger-header-grid'>
              <div className='turbo-charger-grid-title rufusBld no_drag S_heading forground-text-primary'>{translateObject('Turbo Charger')}</div>
              <div className='turbo-charger-grid-container no_drag'>
                <Tooltip title='Close'>
                  <img src={closeIconBlack} alt='close' onClick={handleCloseTurboChargerModal} className='pointer' />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='turbo-charger-body-container sansW4SeLig'>
              <Grid item xs={12} style={{ maxHeight: '70vh', overflow: 'hidden scroll' }}>
                <div className='turbo-charger-input-form'>
                  <div className='turbo-charger-input'>
                    <div className='input-params' style={{ height: '300px', 'marginRight': '15px' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Input Parameters')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      <div className='exchanger_content'>
                        {turboChargeVal.length > 0 && turboChargeVal.map((ele, ind) => {
                          if (ele.name === 'input') {
                            return (
                              <ul key={ind} className={(ind % 2 === 0) ? 'even' : 'odd'}>
                                <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                                <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                                <li className={ele.class}>
                                  <span className='no_drag S_Regular'>
                                    {ele.key !== 'turbo_on_stage' ? (
                                      <input
                                        onMouseDown={(e) => getCurrentValue(e)}
                                        onBlur={(e) => { blurVal(ind, e); }}
                                        onFocus={e => e.target.select()}
                                        onChange={(e) => { changeVal(ind, e); }}
                                        type='text' disabled={!ele.class} value={ele.val} />
                                    ) : (
                                      <Select className='stackmodel' fullWidth style={{ fontSize: 12 }} value={tcSelected} onChange={(e) => { setSeletdValue(e); }}>
                                        {tcParameter.map((tcEle, tcInd) => {
                                          return (
                                            <MenuItem style={{ marginLeft: 0, paddingLeft: '10px' }} disabled={tcInd > tcDisabled} selected={tcSelected} key={tcInd} value={tcInd + 1}>
                                              Before Stage {tcInd + 1}
                                            </MenuItem>
                                          );
                                        })}
                                      </Select>
                                    )}
                                  </span>
                                </li>
                              </ul>
                            );
                          }
                          return '';
                        })}
                      </div>
                    </div>
                    <div className='input-params' style={{ height: '300px' }}>
                      <div className='normal-font f-left rufusReg no_drag M_Bold'>{translateObject('Turbo Charger Performance')}</div>
                      <ul className='work-header'>
                        {headerData.length > 0 && headerData.map((ele, ind) => {
                          return <li key={ind}><span className='no_drag M_Bold secoundary-text-color-Primary-default'>{translateObject(ele)}</span></li>;
                        })}
                      </ul>
                      <div className='exchanger_content'>
                        {turboChargeVal.length > 0 && turboChargeVal.map((ele, ind) => {
                          let flag = true;
                          if (ele.name === 'performance') {
                            if (tcSelected >= 2 && ['power_savings', 'total_power_consumption', 'specific_power_consumption1', 'specific_power_consumption2', 'power_cost_saved'].indexOf(ele.key) >= 0) {
                              flag = false;
                            }
                            if (flag === false) return '';
                            return (
                              <ul key={ind} className={(ind % 2 === 0) ? 'even' : 'odd'}>
                                <li><span className='no_drag S_Regular'>{translateObject(ele.parameter)}</span></li>
                                <li><span className='no_drag S_Regular'>{ele.unit}</span></li>
                                <li className={ele.class}>
                                  <span className='no_drag S_Regular'>
                                    <input
                                      onMouseDown={(e) => getCurrentValue(e)}
                                      onBlur={(e) => { blurVal(ind, e); }}
                                      onFocus={e => e.target.select()}
                                      onChange={(e) => { changeVal(ind, e); }}
                                      type='text' disabled={!ele.class} value={ele.val} />
                                  </span>
                                </li>
                              </ul>
                            );
                          }
                          return '';
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className='edi-button'>
                  <Stack spacing={2} direction='row'>
                    <Button variant='contained' size='small' className='sansW4SeLig ok no_drag M_Bold Primary_Default_Button' onClick={() => setDataOnStorage()}> {translateObject('OK')}</Button>
                  </Stack>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default TurboChargerForm;
